import type { UserInteractionEvent } from "./types/types";

type UserInteractionEventParams = {
  label: string;
  status: string;
};

export const createUserInteractionEvent = ({
  label,
  status,
}: UserInteractionEventParams): UserInteractionEvent => {
  return {
    event: "userInteraction",
    clickInfo: {
      type: "shadow DOM element click",
      label,
      status,
    },
  };
};
